import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const CostingRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.costing_master_create === true ||
    permissions.costing_master_edit === true ||
    permissions.costing_master_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default CostingRouteMiddleware;
